import { CommonModule } from '@angular/common';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SelectModule } from 'primeng/select';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { IftaLabelModule } from 'primeng/iftalabel';
import { CompanyService } from '../../company/company.service';
import { CompanyGroup } from '../../company/company-group.model';
import { SessionStorageService } from '../../services/session-storage.service';

export interface CompanyScopeSelection {
    companyId?: number;
    companyGroupId?: number;
    readOnly: boolean;
    label: string;
}

interface ScopeOption {
    label: string;
    value: string;
    companyId?: number;
    companyGroupId?: number;
    readOnly: boolean;
}

@Component({
    selector: 'app-company-scope-selector',
    standalone: true,
    imports: [CommonModule, FormsModule, SelectModule, InputGroupModule, InputGroupAddonModule, IftaLabelModule],
    template: `
        <div class="field">
            <p-inputGroup>
                <p-inputGroupAddon><i class="pi pi-building"></i></p-inputGroupAddon>
                <p-iftalabel>
                    <p-select inputId="companyScope"
                              [options]="options"
                              [(ngModel)]="selectedValue"
                              optionLabel="label"
                              optionValue="value"
                              styleClass="w-full"
                              (onChange)="emitSelection()"></p-select>
                    <label for="companyScope">Organization scope</label>
                </p-iftalabel>
            </p-inputGroup>
        </div>
    `
})
export class CompanyScopeSelectorComponent implements OnInit {
    @Output() scopeChange = new EventEmitter<CompanyScopeSelection>();

    options: ScopeOption[] = [];
    selectedValue = '';

    constructor(
        private companyService: CompanyService,
        private sessionStorageService: SessionStorageService
    ) {}

    ngOnInit(): void {
        const company = this.sessionStorageService.getCompany();
        if (company?.id) {
            this.options.push({
                label: company.name,
                value: `company:${company.id}`,
                companyId: company.id,
                readOnly: false
            });
            this.selectedValue = `company:${company.id}`;
            this.emitSelection();
        }

        this.companyService.getCompanyGroups(true).subscribe({
            next: (groups: CompanyGroup[]) => {
                this.options = [
                    ...this.options,
                    ...groups.map(group => ({
                        label: `${group.name} (Consolidated)`,
                        value: `group:${group.id}`,
                        companyGroupId: group.id,
                        readOnly: true
                    }))
                ];
            }
        });
    }

    emitSelection(): void {
        const selected = this.options.find(option => option.value === this.selectedValue);
        if (!selected) return;
        this.scopeChange.emit({
            companyId: selected.companyId,
            companyGroupId: selected.companyGroupId,
            readOnly: selected.readOnly,
            label: selected.label
        });
    }
}
